module.exports = __webpack_public_path__ + "img/join-bg (5).bf776d15.jpg";